import { filterNonNullValues } from '@/lib/utils'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { useAuthStore } from '@/stores/authStore'
import Dashboard from '@/views/dashboard'

export const Route = createFileRoute('/_authenticated/dashboard')({
  // A super admin has no cabinet of their own, so the cabinet dashboard shows
  // them an empty agenda. Send them to the platform dashboard instead.
  beforeLoad: async () => {
    const auth = useAuthStore.getState().auth
    if (auth.user?.role === 'Super Admin' || auth.user?.role_name === 'Super Admin') {
      throw redirect({ to: '/super-admin-dashboard' })
    }
  },
  component: Dashboard,
  validateSearch: (search) => filterNonNullValues({
    case_types: Array.isArray(search.case_types) ? search.case_types : null,
    view: typeof search.view === 'string' && ['month', 'day'].includes(search.view) ? search.view : null,
    year: search.year ? Number(search.year) : null,
    month: search.month ? Number(search.month) : null,
    day: search.day ? Number(search.day) : null
  })
})
